import { DesktopAndTablet } from '../../../utils/responsiveQueries';
import { ReactComponent as HeaderFintoIo } from '../../../styles/icon/header/staq-io.svg';
import strings from '../../../lang/lang';
import link from './FintoLink.module.scss';

const FintoLink = () => {
  return (
    <DesktopAndTablet>
      <div className={link.link__wrapper}>
        <a className={link.link} href="https://staq.io/" target="_blank">
          <p>{strings.header.text.mainPageLink}</p>
          <HeaderFintoIo />
        </a>
      </div>
    </DesktopAndTablet>
  );
};

export default FintoLink;
